import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import {ModelImage} from '../../types/models';

interface PollImageInterface {
  img: ModelImage;
}

const PollImageContainer = styled.div`
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${(props) => props.theme.size.borderRadius.imageL};
  }
`;

const PollImage: React.FC<PollImageInterface> = ({img}) => {
  return (
    <PollImageContainer>
      <img src={img.url} alt={img.alt} />
    </PollImageContainer>
  );
};

export default PollImage;
